/* ==========================================================================
   WAVES ALCHEMY — "The Lab"
   Vanilla, no dependencies. Every feature degrades to a working non-JS path
   (real links, real form posts, native <audio> controls).
   ========================================================================== */
(function () {
  'use strict';

  var strings = window.themeStrings || {};
  var routes = window.themeRoutes || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- money ------------------------------------------------------ */
  function formatMoney(cents) {
    var format = strings.moneyFormat || '{{amount}}';
    var value = cents / 100;

    function delimit(num, precision, thousands, decimal) {
      var parts = (num || 0).toFixed(precision).split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return intPart + (parts[1] ? decimal + parts[1] : '');
    }

    if (/amount_no_decimals_with_comma_separator/.test(format)) return format.replace(/\{\{\s*\w+\s*\}\}/, delimit(value, 0, '.', ','));
    if (/amount_with_comma_separator/.test(format)) return format.replace(/\{\{\s*\w+\s*\}\}/, delimit(value, 2, '.', ','));
    if (/amount_no_decimals/.test(format)) return format.replace(/\{\{\s*\w+\s*\}\}/, delimit(value, 0, ',', '.'));
    return format.replace(/\{\{\s*\w+\s*\}\}/, delimit(value, 2, ',', '.'));
  }

  function toast(message) {
    var el = $('#toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-open');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-open'); }, 3200);
  }

  /* ---------- theme toggle ----------------------------------------------- */
  var THEME_KEY = 'wa-theme';
  function applyTheme(mode) {
    document.documentElement.setAttribute('data-theme', mode);
    $$('[data-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false');
      var label = btn.querySelector('[data-theme-label]');
      if (label) label.textContent = mode === 'dark' ? (strings.lightMode || 'Light') : (strings.darkMode || 'Dark');
    });
    try { localStorage.setItem(THEME_KEY, mode); } catch (e) { /* private mode */ }
  }
  $$('[data-theme-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      applyTheme(document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark');
    });
  });
  // Read the stored preference first. The inline script in the head already
  // does this to avoid a flash, but reading it again here means the toggle
  // still survives a reload if that script was blocked or the page came from
  // a cache with the wrong attribute baked in.
  (function initTheme() {
    var stored = null;
    try { stored = localStorage.getItem(THEME_KEY); } catch (e) { /* private mode */ }
    if (stored !== 'light' && stored !== 'dark') {
      stored = document.documentElement.getAttribute('data-theme') || 'light';
    }
    applyTheme(stored);
  })();

  /* ---------- focus trap + overlay panels -------------------------------- */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function trapFocus(container) {
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var items = $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function () { container.removeEventListener('keydown', onKey); };
  }

  var openPanel = null, releaseTrap = null, lastTrigger = null;

  function openOverlay(panel, trigger) {
    if (openPanel === panel) { closeOverlay(); return; }
    if (openPanel) closeOverlay(true);
    openPanel = panel;
    lastTrigger = trigger || document.activeElement;
    /* The sticky header wrapper is its own stacking context, so a panel written
       inside it is trapped below the page overlay. Flag the wrapper while one
       of its panels is open and the stylesheet lifts it over the overlay. */
    var host = panel.closest && panel.closest('.header-section');
    if (host) host.classList.add('has-panel-open');
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    var ov = $('#overlay'); if (ov) ov.classList.add('is-open');
    document.body.classList.add('is-locked');
    releaseTrap = trapFocus(panel);
    var target = panel.querySelector('[data-autofocus]') || panel.querySelector(FOCUSABLE);
    if (target) setTimeout(function () { target.focus(); }, 60);
  }

  function closeOverlay(skipRestore) {
    if (!openPanel) return;
    var host = openPanel.closest && openPanel.closest('.header-section');
    if (host) host.classList.remove('has-panel-open');
    openPanel.classList.remove('is-open');
    openPanel.setAttribute('aria-hidden', 'true');
    if (releaseTrap) { releaseTrap(); releaseTrap = null; }
    openPanel = null;
    var ov = $('#overlay'); if (ov) ov.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    if (!skipRestore && lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-panel-open]');
    if (opener) {
      var panel = document.getElementById(opener.getAttribute('data-panel-open'));
      if (panel) { e.preventDefault(); openOverlay(panel, opener); }
      return;
    }
    if (e.target.closest('[data-panel-close]') || e.target.id === 'overlay') closeOverlay();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) closeOverlay();
  });

  /* ---------- sticky header ---------------------------------------------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 16); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- scroll reveal ---------------------------------------------- */
  var revealTargets = $$('[data-reveal]');
  if (revealTargets.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var siblings = entry.target.parentElement ? $$('[data-reveal]', entry.target.parentElement) : [];
          var idx = siblings.indexOf(entry.target);
          entry.target.style.setProperty('--reveal-delay', (idx > 0 ? Math.min(idx, 6) * 60 : 0) + 'ms');
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
      revealTargets.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---------- animated counters ------------------------------------------ */
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var to = parseFloat(el.getAttribute('data-count')) || 0;
        cio.unobserve(el);
        if (reduceMotion) { el.textContent = to.toLocaleString(); return; }
        var start = null;
        var step = function (t) {
          if (!start) start = t;
          var k = Math.min((t - start) / 1500, 1);
          el.textContent = Math.floor(to * (1 - Math.pow(1 - k, 3))).toLocaleString();
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    $$('[data-count]').forEach(function (el) { cio.observe(el); });
  }

  /* ---------- countdown --------------------------------------------------- */
  $$('[data-countdown]').forEach(function (el) {
    var end = Date.parse(el.getAttribute('data-countdown'));
    if (isNaN(end)) { el.hidden = true; return; }
    var cells = $$('b', el);
    if (cells.length < 4) return;

    var render = function () {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) {
        el.hidden = true;
        var expired = el.parentElement && el.parentElement.querySelector('[data-countdown-expired]');
        if (expired) expired.hidden = false;
        clearInterval(timer);
        return;
      }
      var parts = [Math.floor(left / 86400), Math.floor((left % 86400) / 3600), Math.floor((left % 3600) / 60), left % 60];
      cells.forEach(function (b, i) { b.textContent = String(parts[i]).padStart(2, '0'); });
    };
    render();
    var timer = setInterval(render, 1000);
  });

  /* ---------- flask animation -------------------------------------------- */
  $$('[data-flask]').forEach(function (svg) {
    var w1 = $('[data-wave1]', svg), w2 = $('[data-wave2]', svg), bubbles = $('[data-bubbles]', svg);
    if (!w1 || !w2) return;

    // Waterline and bubble spread are per-vessel: the logo mark and the
    // illustrated flask have different interiors.
    var level = parseFloat(svg.getAttribute('data-level')) || 124;
    var spread = (svg.getAttribute('data-spread') || '52,148').split(',').map(parseFloat);
    var xMin = spread[0], xSpan = Math.max(10, spread[1] - spread[0]);

    function wavePath(offset, amp, lvl) {
      var d = 'M 0 ' + lvl;
      for (var x = 0; x <= 200; x += 5) {
        d += ' L ' + x + ' ' + (lvl + Math.sin(x * 0.045 + offset) * amp + Math.sin(x * 0.11 + offset * 1.7) * amp * 0.34);
      }
      return d + ' L 200 240 L 0 240 Z';
    }

    if (reduceMotion) {
      w1.setAttribute('d', wavePath(0, 0, level));
      w2.setAttribute('d', wavePath(1.6, 0, level + 6));
      return;
    }

    var drops = [];
    if (bubbles) {
      for (var i = 0; i < 9; i++) {
        var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        c.setAttribute('r', (1.4 + Math.random() * 2.6).toFixed(2));
        c.setAttribute('fill', 'rgba(255,255,255,.55)');
        drops.push({ el: c, x: xMin + Math.random() * xSpan, speed: 0.22 + Math.random() * 0.5, y: Math.random() * 70 });
        bubbles.appendChild(c);
      }
    }

    var phase = 0, running = true;

    // Pause when the flask scrolls out of view — no point burning a rAF loop.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        running = entries[0].isIntersecting;
        if (running) requestAnimationFrame(loop);
      }, { threshold: 0 }).observe(svg);
    }

    function loop() {
      if (!running) return;
      phase += 0.028;
      w1.setAttribute('d', wavePath(phase, 3.4, level));
      w2.setAttribute('d', wavePath(phase * 1.35 + 1.6, 2.4, level + 6));
      drops.forEach(function (d) {
        d.y -= d.speed;
        if (d.y < -6) { d.y = 72; d.x = xMin + Math.random() * xSpan; }
        d.el.setAttribute('cx', d.x.toFixed(2));
        d.el.setAttribute('cy', (level + d.y).toFixed(2));
      });
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  });

  /* ---------- card preview player ----------------------------------------- */
  var ICON_PLAY = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>';
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="7" y="5" width="3.4" height="14" rx="1"/><rect x="13.6" y="5" width="3.4" height="14" rx="1"/></svg>';
  var playingCard = null;

  $$('[data-preview-card]').forEach(function (card) {
    var btn = $('[data-preview-play]', card);
    var audio = $('audio', card);
    var chrom = $('.chrom', card);
    if (!btn || !audio) return;

    var bars = [];
    if (chrom && !reduceMotion) {
      for (var i = 0; i < 48; i++) {
        var b = document.createElement('i');
        b.style.left = (i * (100 / 48)) + '%';
        b.style.height = '3px';
        b.style.opacity = (0.55 + Math.random() * 0.45).toFixed(2);
        chrom.appendChild(b);
        bars.push(b);
      }
    }

    var raf = null;
    function animate() {
      bars.forEach(function (b, i) {
        b.style.height = (3 + Math.abs(Math.sin(Date.now() / 230 + i * 0.42)) * (8 + Math.random() * 22)) + 'px';
      });
      raf = requestAnimationFrame(animate);
    }
    function stopAnim() { if (raf) cancelAnimationFrame(raf); raf = null; }

    audio.addEventListener('play', function () {
      if (playingCard && playingCard !== card) playingCard._stop();
      playingCard = card;
      card.classList.add('is-playing-card');
      btn.classList.add('is-playing');
      btn.innerHTML = ICON_PAUSE;
      btn.setAttribute('aria-label', strings.pausePreview || 'Pause preview');
      if (bars.length) animate();
    });

    function reset() {
      card.classList.remove('is-playing-card');
      btn.classList.remove('is-playing');
      btn.innerHTML = ICON_PLAY;
      btn.setAttribute('aria-label', strings.playPreview || 'Play preview');
      stopAnim();
      if (playingCard === card) playingCard = null;
    }
    audio.addEventListener('pause', reset);
    audio.addEventListener('ended', reset);

    card._stop = function () { audio.pause(); };

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (audio.paused) {
        audio.play().catch(function () { toast(strings.previewError || 'Preview unavailable'); });
      } else {
        audio.pause();
      }
    });
  });

  /* Only one audio element plays at a time, anywhere on the page */
  document.addEventListener('play', function (e) {
    if (e.target.tagName !== 'AUDIO') return;
    $$('audio').forEach(function (a) { if (a !== e.target) a.pause(); });
  }, true);

  /* ---------- product gallery -------------------------------------------- */
  $$('[data-gallery]').forEach(function (gallery) {
    var main = $('[data-gallery-main]', gallery);
    if (!main) return;
    $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        if (src) { main.src = src; main.alt = thumb.getAttribute('data-alt') || ''; }
        if (srcset) main.srcset = srcset;
        $$('[data-gallery-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- variant picker ---------------------------------------------- */
  $$('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    var root = picker.closest('[data-product-root]') || document;
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var dataEl = $('[data-variant-data]', picker);
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (err) { variants = []; }
    if (!variants.length) return;

    function update() {
      var sel = $$('[data-option-group]', picker).map(function (group) {
        var checked = group.querySelector('[aria-checked="true"]');
        return checked ? checked.getAttribute('data-value') : null;
      });
      var match = variants.find(function (v) {
        return sel.every(function (val, i) { return val === null || v.options[i] === val; });
      });
      if (!match) return;

      if (idInput) idInput.value = match.id;

      var priceEl = $('[data-product-price]', root);
      if (priceEl) priceEl.textContent = match.price === 0 ? (strings.free || 'Free') : formatMoney(match.price);

      var compareEl = $('[data-product-compare]', root);
      if (compareEl) {
        var show = match.compare_at_price && match.compare_at_price > match.price;
        compareEl.textContent = show ? formatMoney(match.compare_at_price) : '';
        compareEl.hidden = !show;
      }

      var submit = form ? form.querySelector('[data-add-to-cart]') : null;
      if (submit) {
        submit.disabled = !match.available;
        var label = submit.querySelector('[data-atc-label]');
        if (label) label.textContent = match.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      }

      if (history.replaceState && match.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-value]', picker).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-value]', btn.closest('[data-option-group]')).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');
        update();
      });
    });
  });

  /* ---------- cart -------------------------------------------------------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function renderCartDrawer(cart) {
    var body = $('[data-cart-items]');
    var foot = $('[data-cart-foot]');
    var empty = $('[data-cart-empty]');
    if (!body) return;

    updateCartCount(cart.item_count);

    if (!cart.items.length) {
      body.innerHTML = '';
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x160$1$2') + '" alt="" width="76" height="76" loading="lazy">'
        : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '';
      return '' +
        '<div class="cart-line" data-line="' + item.key + '">' +
          '<a class="cart-line__media" href="' + item.url + '">' + img + '</a>' +
          '<div class="cart-line__body">' +
            '<a class="cart-line__title" href="' + item.url + '">' + item.product_title + '</a>' + variant +
            (item.quantity > 1 ? '<div class="cart-line__variant">&times; ' + item.quantity + '</div>' : '') +
            '<button type="button" class="cart-line__remove" data-line-remove>' + (strings.remove || 'Remove') + '</button>' +
          '</div>' +
          '<div class="price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    var totalEl = $('[data-cart-total]');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    /* total_discount is whatever Shopify actually applied — automatic discount,
       discount code, or nothing. Re-read on every render so the row appears the
       moment a quantity change crosses a bundle threshold, and disappears again
       the moment it stops qualifying. */
    var savedEl = $('[data-cart-saved]');
    if (savedEl) {
      var saved = cart.total_discount || 0;
      savedEl.hidden = saved <= 0;
      var wasEl = $('[data-cart-was]');
      if (wasEl) wasEl.textContent = formatMoney(cart.original_total_price);
      var savedAmountEl = $('[data-cart-saved-amount]');
      if (savedAmountEl) savedAmountEl.textContent = formatMoney(saved);
    }
  }

  function fetchCart() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCartDrawer(cart);
      if (document.body.classList.contains('template-cart')) window.location.reload();
      return cart;
    });
  }

  /* A download is bought once. Hiding the stepper is not enough on its own,
     because it was never the only way to end up with two of the same file in
     the cart — a double click on add, a quick add on a kit already in there,
     an old /cart/<variant>:2 link all do it, and the customer pays twice for
     one download and asks for the money back. So any line that comes back
     above a single unit is pulled down to one before the cart is drawn.

     Deliberately not changeLine(): that redraws and reloads, and this runs in
     the middle of a chain that is about to do both. */
  function normalizeUnits(cart) {
    var over = (cart && cart.items || []).filter(function (item) { return item.quantity > 1; });
    if (!over.length) return Promise.resolve(cart);
    return over.reduce(function (chain, item) {
      return chain.then(function () {
        return fetch(routes.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 1 })
        }).then(function (r) { return r.json(); });
      });
    }, Promise.resolve()).then(function (corrected) { return corrected || cart; });
  }

  var cartDrawer = $('#cart-drawer');
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line]');
      if (!line) return;
      if (!e.target.closest('[data-line-remove]')) return;
      changeLine(line.getAttribute('data-line'), 0);
    });
  }

  /* The cart page is server-rendered, so a line above one unit is already on
     screen by the time the script runs. The flag is set in Liquid, which means
     the correction costs a request only on the rare cart that needs it. */
  if ($('[data-cart-over-units]') && window.fetch) {
    fetchCart().then(normalizeUnits).then(function () { window.location.reload(); });
  }

  $$('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !cartDrawer) return; // plain form POST fallback
      e.preventDefault();

      var button = form.querySelector('[data-add-to-cart]');
      var label = button ? button.querySelector('[data-atc-label]') : null;
      var original = label ? label.textContent : '';
      if (button) button.disabled = true;
      if (label) label.textContent = strings.adding || 'Adding…';

      fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Error');
          return fetchCart().then(normalizeUnits);
        })
        .then(function (cart) { renderCartDrawer(cart); openOverlay(cartDrawer, button); })
        .catch(function (err) { toast(err.message || strings.error || 'Something went wrong'); })
        .then(function () {
          if (button) button.disabled = false;
          if (label) label.textContent = original;
        });
    });
  });

  /* Every add that goes through wa-lab.js — quick add, bundle add — ends by
     clicking this opener, so normalising here covers those paths too without
     either file needing to know about the other. */
  $$('[data-panel-open="cart-drawer"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (window.fetch) fetchCart().then(normalizeUnits).then(renderCartDrawer);
    });
  });

  /* ---------- collection sort --------------------------------------------- */
  var sortSelect = $('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- exclusive accordions ---------------------------------------- */
  $$('[data-accordion-exclusive]').forEach(function (group) {
    $$('details', group).forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        $$('details', group).forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  });
})();
